module.exports = __webpack_public_path__ + "img/practice-4.5fb73ad1.jpg";